(function () {

	function debounce(fn, delay = 300) {
		let t;
		return (...args) => {
			clearTimeout(t);
			t = setTimeout(() => fn(...args), delay);
		};
	}

	function getValues(filterName) {
		return Array.from(
			document.querySelectorAll(`input[name="${filterName}"]`)
		)
		.map(el => parseFloat(el.dataset.label))
		.filter(v => !isNaN(v))
		.sort((a, b) => a - b);
	}

	function applyRange(filterName, min, max) {
		const url = new URL(window.location.href);
		const params = new URLSearchParams(url.search);

		params.delete(filterName);

		const options = getValues(filterName);

		const filtered = options.filter(v => {
			if (min !== "" && !isNaN(min) && v < min) return false;
			if (max !== "" && !isNaN(max) && v > max) return false;
			return true;
		});

		filtered.forEach(v => params.append(filterName, v));

		url.search = params.toString();
		window.location.href = url.toString();
	}

	function syncInputsWithURL() {
		const params = new URLSearchParams(window.location.search);

		document.querySelectorAll(".range-filter").forEach((container) => {
			const filterName = container.dataset.filter;

			const values = params
				.getAll(filterName)
				.map(Number)
				.filter(v => !isNaN(v))
				.sort((a, b) => a - b);

			const minInput = container.querySelector(".range-filter__min");
			const maxInput = container.querySelector(".range-filter__max");

			if (!minInput || !maxInput) return;

			if (!values.length) {
				minInput.value = "";
				maxInput.value = "";
				return;
			}

			minInput.value = values[0];
			maxInput.value = values[values.length - 1];
		});
	}

	function setMinMaxPlaceholders() {
		document.querySelectorAll(".range-filter").forEach((container) => {
			const filterName = container.dataset.filter;

			const minInput = container.querySelector(".range-filter__min");
			const maxInput = container.querySelector(".range-filter__max");

			if (!minInput || !maxInput) return;

			const values = getValues(filterName);

			// ❗ IMPORTANT: jeśli brak danych → NIE NADPISUJ NIC
			if (!values.length) return;

			const min = values[0];
			const max = values[values.length - 1];

			if (!minInput.value) minInput.placeholder = min;
			if (!maxInput.value) maxInput.placeholder = max;
		});
	}

	function initRangeFilter(container) {
		const filterName = container.dataset.filter;

		const minInput = container.querySelector(".range-filter__min");
		const maxInput = container.querySelector(".range-filter__max");

		if (!minInput || !maxInput) return;

		const run = debounce(() => {
			applyRange(filterName, minInput.value, maxInput.value);
		}, 400);

		minInput.addEventListener("input", run);
		maxInput.addEventListener("input", run);
	}

	// 🔥 KLUCZ: czekamy aż Shopify skończy render po clear all
	function waitUntilStable(callback) {
		let lastCount = -1;
		let stableTicks = 0;

		const interval = setInterval(() => {
			const count = document.querySelectorAll(".range-filter input[data-label]").length;

			if (count === lastCount) {
				stableTicks++;
			} else {
				stableTicks = 0;
				lastCount = count;
			}

			// musi być stabilne kilka ticków
			if (stableTicks >= 3) {
				clearInterval(interval);
				callback();
			}
		}, 120);
	}

	function refreshAll() {
		waitUntilStable(() => {
			syncInputsWithURL();
			setMinMaxPlaceholders();
		});
	}

	function init() {
		document.querySelectorAll(".range-filter").forEach(initRangeFilter);

		syncInputsWithURL();
		setMinMaxPlaceholders();

		observe();
	}

	function observe() {
		const target = document.querySelector("facet-inputs-component");
		if (!target) return;

		const observer = new MutationObserver(() => {
			refreshAll();
		});

		observer.observe(target, {
			childList: true,
			subtree: true
		});
	}

	function waitForInit() {
		const check = setInterval(() => {
			if (document.querySelector(".range-filter")) {
				clearInterval(check);
				init();
			}
		}, 300);
	}

	waitForInit();

})();